import { render, staticRenderFns } from "./MpEffectGetItem.vue?vue&type=template&id=4290201c&scoped=true&"
import script from "./MpEffectGetItem.vue?vue&type=script&lang=js&"
export * from "./MpEffectGetItem.vue?vue&type=script&lang=js&"
import style0 from "./MpEffectGetItem.vue?vue&type=style&index=0&id=4290201c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290201c",
  null
  
)

export default component.exports